var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-contanier",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item, $index) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: item.permissson,
                class: ["tabItem", _vm.active === $index ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.changeType($index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "opt" },
        [
          _c(
            "BaseFilter",
            {
              attrs: { isActive: _vm.isActive, width: 466 },
              on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
            },
            [
              _c(
                "div",
                { staticClass: "filter" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.filterList, "label-width": "70px" },
                    },
                    [
                      _vm.active === 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "客户" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择状态",
                                  },
                                  model: {
                                    value: _vm.filterList.companyId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "companyId", $$v)
                                    },
                                    expression: "filterList.companyId",
                                  },
                                },
                                _vm._l(_vm.companyDrapdown, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            { attrs: { label: "代理" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择状态",
                                  },
                                  model: {
                                    value: _vm.filterList.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "supplierId",
                                        $$v
                                      )
                                    },
                                    expression: "filterList.supplierId",
                                  },
                                },
                                _vm._l(_vm.supplierOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                      _vm.active === 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "销售" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择销售",
                                  },
                                  model: {
                                    value: _vm.filterList.saleId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "saleId", $$v)
                                    },
                                    expression: "filterList.saleId",
                                  },
                                },
                                _vm._l(_vm.userOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  pageSizes: [20, 30, 50, 100],
                  loading: _vm.loading,
                  isPager: true,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  handleSelectionChange: _vm.handleSelectionChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson": _vm.newVerification,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.verification(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("核销")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson": _vm.newVerificationLog,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.verificationLog(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("核销记录")]
                                  ),
                                ]),
                              ]),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2849397144
                ),
              })
            : _vm._e(),
          _c("VerificationLogDrawer", {
            attrs: {
              drawer: _vm.drawer,
              active: _vm.active,
              rowData: _vm.rowData,
            },
            on: {
              close: function ($event) {
                _vm.drawer = false
              },
            },
          }),
          _c("VerificationAndWaterDrawer", {
            attrs: {
              drawer: _vm.drawer1,
              rowData: _vm.rowData,
              active: _vm.active,
            },
            on: {
              close: function ($event) {
                _vm.drawer1 = false
              },
              ok: function ($event) {
                _vm.drawer1 = false
                _vm.getList(_vm.pager)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }